import React from 'react';
import Button from '../../../../shared/components/Button/Button';
import { adminSections } from '../wiki.constants';
import {
  ArticleIcon,
  CategoryIcon,
  FolderIcon,
  HistoryIcon,
  SearchIcon,
  StarIcon,
} from './WikiIcons';

function WikiSidebar({ mode, routeValue, categories, articles, navigate }) {
  const navButtonProps = (active) => ({
    'aria-current': active ? 'page' : undefined,
    className: `wiki-nav-button ${active ? 'active' : ''}`,
    variant: 'ghost',
  });

  return (
    <aside className="wiki-sidebar">
      <div className="wiki-sidebar-title">Espace documentaire</div>
      <Button {...navButtonProps(mode === 'home')} onClick={() => navigate('/wiki')}>
        <ArticleIcon fontSize="small" /> <span>Accueil</span>
      </Button>
      <Button {...navButtonProps(mode === 'search')} onClick={() => navigate('/wiki/search')}>
        <SearchIcon fontSize="small" /> <span>Recherche</span>
      </Button>
      <Button {...navButtonProps(mode === 'favorites')} onClick={() => navigate('/wiki/favorites')}>
        <StarIcon fontSize="small" /> <span>Favoris</span>
      </Button>
      <Button {...navButtonProps(mode === 'recent')} onClick={() => navigate('/wiki/recent')}>
        <HistoryIcon fontSize="small" /> <span>Consultés récemment</span>
      </Button>

      <div className="wiki-sidebar-title">Categories</div>
      {categories.filter((category) => !category.parent).map((category) => (
        <Button
          key={category.slug}
          {...navButtonProps(mode === 'category' && routeValue === category.slug)}
          onClick={() => navigate(`/wiki/category/${category.slug}`)}
        >
          <FolderIcon fontSize="small" />
          <span>{category.name}</span>
          <span className="wiki-count">{category.count}</span>
        </Button>
      ))}

      <div className="wiki-sidebar-title">Gestion</div>
      {adminSections.map((section) => (
        <Button
          key={section.key || 'all'}
          {...navButtonProps(mode === 'admin' && (routeValue || '') === section.key)}
          onClick={() => navigate(section.key ? `/wiki/admin/${section.key}` : '/wiki/admin')}
        >
          <CategoryIcon fontSize="small" />
          <span>{section.label}</span>
          <span className="wiki-count">{section.status ? articles.filter((article) => article.status === section.status).length : articles.length}</span>
        </Button>
      ))}
      <Button {...navButtonProps(mode === 'admin' && routeValue === 'categories')} onClick={() => navigate('/wiki/admin/categories')}>
        <FolderIcon fontSize="small" /> <span>Catégories</span>
      </Button>
    </aside>
  );
}

export default WikiSidebar;
